var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"new-cls content"},[_c('Tabs',{staticStyle:{"padding":"0 24px"},attrs:{"tabsList":_vm.tabsList,"activeName":_vm.activeVal},on:{"tab-click":_vm.handleChange}}),(_vm.activeVal == '1')?_c('BaseInfoView'):_vm._e(),(_vm.activeVal == '2')?_c('ParamsSettingView'):_vm._e(),(_vm.activeVal == '3')?_c('HolidayConfigView'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }